var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',{staticStyle:{"height":"100%"}},[_c('el-header',[_c('Nav')],1),_c('el-main',[_c('Body')],1),_c('el-footer',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":""}},[_vm._v("粤ICP备2023017790号-1")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }